import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { OperatorReportNeedLoveFormInput } from '@/models/needLove';

export const postOperatorReportNLForm = async (data: OperatorReportNeedLoveFormInput) => {
  const response = await mutationExecute({
    variables: {
      data,
    },
    mutation: graphql(`
      mutation PostOperatorReportNLForm($data: OperatorReportNlFormInputType!) {
        postOperatorReportNLForm(data: $data)
      }
    `),
  });

  return response.data!.postOperatorReportNLForm ?? '';
};
